// import React, { useEffect, useState } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Form,
//   Button,
//   InputGroup,
// } from "react-bootstrap";
// import "./RankRewards.css";
// import CommonBreadcrumb from "./../../../../common_components/breadcrumb/CommonBreadcrumb";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCalendarDays, faUsers } from "@fortawesome/free-solid-svg-icons";
// import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   GETLevel,
//   GETLevelDetails,
//   GetUserLevelDetails,
// } from "../../../../../features/admin/auth/Slice";

// const levelData = [
//   {
//     id: 1,
//     title: "Referrer",
//     customers: 2,
//     points: 30,
//     description:
//       "Each referral earns 15 points, and with 2 customers, you generate 30 total points. This is the foundation of your network.",
//   },
//   {
//     id: 2,
//     title: "Retailer",
//     customers: 12,
//     points: 180,
//     description:
//       "As your network grows, you reach the Retailer level. With 12 customers, you earn 180 total referral points.",
//   },
//   {
//     id: 3,
//     title: "Retailer",
//     customers: 12,
//     points: 180,
//     description:
//       "As your network grows, you reach the Retailer level. With 12 customers, you earn 180 total referral points.",
//   },
//   {
//     id: 4,
//     title: "Retailer",
//     customers: 12,
//     points: 180,
//     description:
//       "As your network grows, you reach the Retailer level. With 12 customers, you earn 180 total referral points.",
//   },
//   {
//     id: 5,
//     title: "Retailer",
//     customers: 12,
//     points: 180,
//     description:
//       "As your network grows, you reach the Retailer level. With 12 customers, you earn 180 total referral points.",
//   },
//   {
//     id: 6,
//     title: "Retailer",
//     customers: 12,
//     points: 180,
//     description:
//       "As your network grows, you reach the Retailer level. With 12 customers, you earn 180 total referral points.",
//   },
//   {
//     id: 7,
//     title: "Retailer",
//     customers: 12,
//     points: 180,
//     description:
//       "As your network grows, you reach the Retailer level. With 12 customers, you earn 180 total referral points.",
//   },
// ];

// const RankRewards = () => {
//   const breadcrumbItems = [
//     { label: "Profile", link: "/profile" },
//     { label: "Rank & Rewards" },
//   ];

//   const dispatch = useDispatch();
//   const levelprofile = useSelector(
//     (state) => state?.auth?.login?.getLevelData?.levels,
//   );
//   const leveldetails = useSelector(
//     (state) => state?.auth?.login?.getLeveldetailsData,
//   );
//   const userleveldetails = useSelector(
//     (state) => state?.auth?.login?.getUserLevelData,
//   );

//   console.log(
//     userleveldetails,
//     "userleveldetailsuserleveldetailsuserleveldetails",
//   );
//   useEffect(() => {
//     dispatch(GETLevel());
//     dispatch(GETLevelDetails(""));
//     dispatch(GetUserLevelDetails());
//   }, [dispatch]);

//   const [search, setSearch] = useState("");
//   const [date, setDate] = useState("");

//   const handleSearch = () => {
//     let finalSearch = search;

//     if (date) {
//       const formattedDate = date.replaceAll("-", "/"); // yyyy-mm-dd → yyyy/mm/dd
//       finalSearch = formattedDate;
//     }

//     dispatch(GETLevelDetails(finalSearch));
//   };

//   // console.log(leveldetails,"leveldetails+++++");

//   return (
//     <section className="rank-section">
//       <CommonBreadcrumb items={breadcrumbItems} />
//       <Container>
//         <Row className="justify-content-center ">
//           {/* LEFT SIDE */}
//           <Col lg={7} className="left-side">
//             {/* ✅ TOP SUMMARY CARD */}
//             <Card className="rank-summary-card">
//               <Card.Body>
//                 <p className="small-text">
//                   Your Rank Level {userleveldetails?.level_id}.
//                 </p>
//                 <h2 className="rank-title">
//                   {userleveldetails?.level_name}{" "}
//                   <span>
//                     <div className="dot"></div>{" "}
//                     <FontAwesomeIcon icon={faUsers} />{" "}
//                     {userleveldetails?.referral_count} Customers
//                   </span>
//                 </h2>

//                 <div className="points-row">
//                   <h5>
//                     <img src="/images/profile/star.png" alt="" />{" "}
//                     {userleveldetails?.points} Pts
//                   </h5>
//                   <span className="next-level">
//                     Next Level: {userleveldetails?.next_level_name}
//                   </span>
//                 </div>
//               </Card.Body>
//             </Card>

//             {levelprofile?.map((level) => (
//               <div className="level-outer" key={level.id}>
//                 {/* Red Background Card */}
//                 <div className="level-red-bg">
//                   {/* Vertical Level Badge */}
//                   <div className="level-badge">
//                     Level {level?.id}
//                     {/* {level.id.toString().padStart(2, "0")} */}
//                   </div>

//                   {/* White Front Card */}
//                   <Card className="level-inner-card">
//                     <Card.Body>
//                       <Row className="lavel-card-row">
//                         <Col md={8}>
//                           <h5 className="level-title">
//                             {level?.name}
//                             <span className="customers">
//                               {" "}
//                               <div className="dot"></div>{" "}
//                               <FontAwesomeIcon icon={faUsers} />{" "}
//                               {/* {level.customers} Customers */}
//                               {level?.user_count} Customers
//                             </span>
//                           </h5>
//                           <p className="level-desc">{level?.description}</p>
//                         </Col>

//                         <Col
//                           md={4}
//                           className="text-md-end mt-3 mt-md-0 point-box"
//                         >
//                           <p className="points-label">Total Referral Pts.</p>
//                           <h4 className="points">
//                             <img src="/images/profile/star.png" alt="" />
//                             {/* {level.points.toLocaleString()} */}
//                             {level?.total_points}
//                           </h4>
//                         </Col>
//                       </Row>
//                     </Card.Body>
//                   </Card>
//                 </div>
//               </div>
//             ))}
//           </Col>

//           {/* RIGHT SIDE */}
//           <Col lg={4} className="mt-4 mt-lg-0  right-side ">
//             <Card className="history-card ">
//               <Card.Body>
//                 <h6>History of level</h6>

//                 {/* <div className="search-box">
//                   <InputGroup className="inputgroup">
//                     <FontAwesomeIcon
//                       className="glass-icon"
//                       icon={faMagnifyingGlass}
//                     />
//                     <Form.Control
//                       type="text"
//                       placeholder="Search by name, date, id"
//                       value={search}
//                       onChange={(e) => setSearch(e.target.value)}
//                     />
//                     <Button
//                       className="search-btn"
//                       variant="primary"
//                       onClick={() => dispatch(GETLevelDetails(search))}
//                     >
//                       Search
//                     </Button>
//                   </InputGroup>
//                 </div> */}
//                 <div className="search-box">
//                   {/* <InputGroup className="inputgroup">
//                     <FontAwesomeIcon
//                       className="glass-icon"
//                       icon={faMagnifyingGlass}
//                     />

//                     <Form.Control
//                       type="text"
//                       placeholder="Search by name,number"
//                       value={search}
//                       onChange={(e) => setSearch(e.target.value)}
//                     />

//                     <Form.Control
//                       type="date"
//                       value={date}
//                       onChange={(e) => setDate(e.target.value)}
//                       placeholder=""
//                     />

//                   </InputGroup> */}

//                   <InputGroup className="inputgroup">
//                     {/* 🔍 Search Icon */}
//                     <FontAwesomeIcon
//                       className="glass-icon"
//                       icon={faMagnifyingGlass}
//                     />

//                     {/* 🔍 Main Search Input */}
//                   <Form.Control
//                       type="text"
//                       placeholder="Search by name,number,date"
//                       value={search}
//                       onChange={(e) => setSearch(e.target.value)}
//                     />

//                     {/* 📅 Hidden Date Input */}
//                     <input
//                       type="date"
//                       value={date}
//                       onChange={(e) => {
//                         const selectedDate = e.target.value;
//                         setDate(selectedDate);

//                         // convert yyyy-mm-dd → yyyy/mm/dd
//                         const formattedDate = selectedDate.replaceAll("-", "/");

//                         // put date into search bar
//                         setSearch(formattedDate);
//                       }}
//                       style={{
//                         position: "absolute",
//                         opacity: 0,
//                         pointerEvents: "none",
//                       }}
//                       id="hiddenDateInput"
//                     />

//                     {/* 📅 Calendar Icon */}
//                     <Button
//                       variant="light"
//                       onClick={() =>
//                         document.getElementById("hiddenDateInput").showPicker()
//                       }
//                     >
//                       <FontAwesomeIcon icon={faCalendarDays} />
//                     </Button>
//                   </InputGroup>

//                   <div className="btn_holder">
//                     {/* 🔍 Search Button */}
//                     <Button
//                       className="search-btn"
//                       variant="primary"
//                       onClick={handleSearch}
//                     >
//                       Search
//                     </Button>

//                     {/* 🔄 Reset Button */}
//                     <Button
//                       variant="secondary"
//                       className="search-btn"
//                       onClick={() => {
//                         setSearch("");
//                         setDate("");
//                         dispatch(GETLevelDetails("")); // reset API
//                       }}
//                     >
//                       Reset
//                     </Button>
//                   </div>
//                 </div>
//                 {leveldetails?.map((levelDetail) => (
//                   <>
//                     <div className="lavel-divider">
//                       <p>Level 0 {levelDetail?.level}</p>
//                     </div>
//                     {levelDetail?.users?.map((user) => (
//                       <div className="history-item">
//                         <p>
//                           <strong>Name:</strong> {user?.consumer_name}
//                         </p>
//                         <p>
//                           <strong>Contact No:</strong> +91 {user?.mobile}
//                         </p>
//                         <p>
//                           <strong>Joining Date:</strong> {user?.joining_date}
//                         </p>
//                       </div>
//                     ))}
//                   </>
//                 ))}
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default RankRewards;

import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
} from "react-bootstrap";
import "./RankRewards.css";
import CommonBreadcrumb from "./../../../../common_components/breadcrumb/CommonBreadcrumb";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faUsers } from "@fortawesome/free-solid-svg-icons";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  GETLevel,
  GETLevelDetails,
  GetUserLevelDetails,
} from "../../../../../features/admin/auth/Slice";

const RankRewards = () => {
  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Rank & Rewards" },
  ];

  const dispatch = useDispatch();

  const levelprofile = useSelector(
    (state) => state?.auth?.login?.getLevelData?.levels,
  );

  const leveldetails = useSelector(
    (state) => state?.auth?.login?.getLeveldetailsData,
  );

  const userleveldetails = useSelector(
    (state) => state?.auth?.login?.getUserLevelData,
  );

  const [search, setSearch] = useState("");
  const [date, setDate] = useState("");

  // ✅ DEFAULT LEVEL 1 SELECTED
  const [selectedLevelId, setSelectedLevelId] = useState(1);

  // ✅ INITIAL LOAD WITH LEVEL 1
  useEffect(() => {
    dispatch(GETLevel());

    dispatch(
      GETLevelDetails({
        search: "",
        level_id: 1,
      }),
    );

    dispatch(GetUserLevelDetails());
  }, [dispatch]);

  // ✅ SEARCH WITH LEVEL FILTER
  const handleSearch = () => {
    let finalSearch = search;

    if (date) {
      const formattedDate = date.replaceAll("-", "/");
      finalSearch = formattedDate;
    }

    dispatch(
      GETLevelDetails({
        search: finalSearch,
        level_id: selectedLevelId,
      }),
    );
  };

  return (
    <section className="rank-section">
      <CommonBreadcrumb items={breadcrumbItems} />
      <Container>
        <Row className="justify-content-center ">
          {/* LEFT SIDE */}
          <Col lg={7} className="left-side">
            <Card className="rank-summary-card">
              <Card.Body>
                <p className="small-text">
                  Your Rank Level {userleveldetails?.level_id}.
                </p>
                <h2 className="rank-title">
                  {userleveldetails?.level_name}
                  <span>
                    <div className="dot"></div>
                    <FontAwesomeIcon icon={faUsers} />
                    {userleveldetails?.referral_count} Customers
                  </span>
                </h2>

                <div className="points-row">
                  <h5>
                    <img src="/images/profile/star.png" alt="" />
                    {userleveldetails?.points} Pts
                  </h5>
                  <span className="next-level">
                    Next Level: {userleveldetails?.next_level_name}
                  </span>
                </div>
              </Card.Body>
            </Card>

            {/* ✅ CLICK LEVEL CARD */}
            {levelprofile?.map((level) => (
              <div
                className={`level-outer ${
                  selectedLevelId === level.id ? "active-level" : ""
                }`}
                key={level.id}
                onClick={() => {
                  setSelectedLevelId(level.id);

                  dispatch(
                    GETLevelDetails({
                      search: search,
                      level_id: level.id,
                    }),
                  );
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="level-red-bg">
                  <div className="level-badge">Level {level?.id}</div>

                  <Card className="level-inner-card">
                    <Card.Body>
                      <Row className="lavel-card-row">
                        <Col md={8}>
                          <h5 className="level-title">
                            {level?.name}
                            <span className="customers">
                              <div className="dot"></div>
                              <FontAwesomeIcon icon={faUsers} />
                              {level?.user_count} Customers
                            </span>
                          </h5>
                          <p className="level-desc">{level?.description}</p>
                        </Col>

                        <Col md={4} className="text-md-end point-box">
                          <p className="points-label">Total Referral Pts.</p>
                          <h4 className="points">
                            <img src="/images/profile/star.png" alt="" />
                            {level?.total_points}
                          </h4>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            ))}
          </Col>

          {/* RIGHT SIDE */}
          <Col lg={4} className="right-side">
            <Card className="history-card">
              <Card.Body>
                <h6>History of level</h6>

                <div className="search-box">
                  <InputGroup className="inputgroup">
                    <FontAwesomeIcon
                      className="glass-icon"
                      icon={faMagnifyingGlass}
                    />

                    <Form.Control
                      type="text"
                      placeholder="Search by name,number,date"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />

                    <input
                      type="date"
                      value={date}
                      onChange={(e) => {
                        const selectedDate = e.target.value;
                        setDate(selectedDate);
                        setSearch(selectedDate.replaceAll("-", "/"));
                      }}
                      style={{
                        position: "absolute",
                        opacity: 0,
                        pointerEvents: "none",
                      }}
                      id="hiddenDateInput"
                    />

                    <Button
                      variant="light"
                      onClick={() =>
                        document.getElementById("hiddenDateInput").showPicker()
                      }
                    >
                      <FontAwesomeIcon icon={faCalendarDays} />
                    </Button>
                  </InputGroup>

                  <div className="btn_holder">
                    <Button className="search-btn" onClick={handleSearch}>
                      Search
                    </Button>

                    <Button
                      className="search-btn"
                      variant="secondary"
                      onClick={() => {
                        setSearch("");
                        setDate("");
                        setSelectedLevelId(1);

                        dispatch(
                          GETLevelDetails({
                            search: "",
                            level_id: 1,
                          }),
                        );
                      }}
                    >
                      Reset
                    </Button>
                  </div>
                </div>

                {leveldetails?.map((levelDetail) => (
                  <div key={levelDetail?.level}>
                    <div className="lavel-divider">
                      <p>Level 0 {levelDetail?.level}</p>
                    </div>

                    {levelDetail?.users?.map((user, index) => (
                      <div className="history-item" key={index}>
                        <p>
                          <strong>Name:</strong> {user?.consumer_name}
                        </p>
                        <p>
                          <strong>Contact No:</strong> +91 {user?.mobile}
                        </p>
                        <p>
                          <strong>Joining Date:</strong> {user?.joining_date}
                        </p>
                      </div>
                    ))}
                  </div>
                ))}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default RankRewards;
